import React, { useState } from "react";
import Select from "react-select";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useLocation } from "react-router-dom";
import { useMutation, useQuery } from "@apollo/client";
import { ASSIGN_FRANCHISES_TO_RO, GET_ALL_FRANCHISES, GET_RO_BY_ID } from "../../graphql/Query/GETALLFRANCHISELIST.js";
import { toast } from "react-toastify";

const customStyles = {
    control: (provided) => ({
        ...provided,
        backgroundColor: "white",
        borderColor: "black",
        boxShadow: "none",
        "&:hover": { borderColor: "black" },
    }),
    multiValue: (provided) => ({
        ...provided,
        backgroundColor: "black",
        color: "white",
    }),
    multiValueLabel: (provided) => ({
        ...provided,
        color: "white",
    }),
    multiValueRemove: (provided) => ({
        ...provided,
        color: "white",
        ":hover": {
            backgroundColor: "white",
            color: "black",
        },
    }),
    menu: (provided) => ({
        ...provided,
        backgroundColor: "white",
        border: "1px solid black",
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? "black" : state.isFocused ? "#f0f0f0" : "white",
        color: state.isSelected ? "white" : "black",
    }),
};

const FranchiseAddFrom = () => {
    const location = useLocation();
    // console.log('✌️location?.state?.id --->', location?.state?.id);
    const { data: franchiseData } = useQuery(GET_ALL_FRANCHISES, {
        fetchPolicy: "cache-and-network"
    });
    const { data: roData, refetch } = useQuery(GET_RO_BY_ID, {
        variables: { id: location?.state?.id },
        fetchPolicy: "cache-and-network"
    });

    const [assignFranchises] = useMutation(ASSIGN_FRANCHISES_TO_RO);

    const options = franchiseData?.getAllFranchises?.map(f => ({
        value: f?._id,
        label: f?.username
    })) || [];

    const initialSelected = roData?.getROById?.franchises?.map(f => ({
        value: f?._id,
        label: f?.username
    })) || [];

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: { franchises: initialSelected },
        validationSchema: Yup.object({
            franchises: Yup.array().min(1, "Please select at least one franchise"),
        }),
        onSubmit: async (values) => {
            try {

                const franchiseIds = values.franchises.map(s => s?.value);
                await assignFranchises({ variables: { roId: location?.state?.id, franchiseIds } });
                toast.success("Franchises updated successfully!");
                refetch();
            } catch (error) {
                toast.error(error?.message)
            }
        },
    });

    return (
        <form onSubmit={formik.handleSubmit} className="w-full max-w-md mx-auto p-4">
            <label className="text-black font-semibold mb-2 block">Select Franchises</label>
            <Select
                isMulti
                options={options}
                value={formik.values.franchises}
                onChange={(val) => formik.setFieldValue("franchises", val)}
                styles={customStyles}
                placeholder="Search and select..."
            />

            {/* Error Message */}
            {formik.touched.franchises && formik.errors.franchises && (
                <p className="text-red-500 text-sm mt-1">{formik.errors.franchises}</p>
            )}

            {/* Submit Button */}
            <div className="flex justify-center mt-5">
                <button
                    type="submit"
                    className="bg-black text-white px-6 py-2 rounded-lg hover:bg-gray-700 transition"
                >
                    Submit
                </button>
            </div>
        </form>
    );
};

export default FranchiseAddFrom;
